import { useImperativeHandle, useRef } from "react";

import { ContextMenu } from "@/appComponents/Blocks/Composites/ContextMenu/ContextMenu";
import { GetWSMgr, ReRenderCanvas } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { enumBoxSubTypes } from "@coreapp/constants";

export const BackgroundContextMenu = props => {
  const openCtrlRef = useRef(null);
  useImperativeHandle(props.openCtrlRef, () => openCtrlRef.current);

  const handleClickCommand = cmd => (option, e) => {
    openCtrlRef.current?.setOpen(false);

    const wsMgr = GetWSMgr();
    if (!wsMgr) {
      return;
    }

    const cp = wsMgr.fCanvasPanel;
    const chartBox = cp.GetFirstSelectedBox(false);
    const aCmd = wsMgr.AssembleCommand(chartBox, cp, `CanvasRightClick_${cmd}`);
    aCmd.fEvent = e;
    aCmd["newvalue"] = cmd;
    wsMgr.HandleRightClickCmd("CanvasRightClick", aCmd);
    ReRenderCanvas();
  };

  const BuildOptions = () => {
    let options = [];
    switch (props.subType) {
      case enumBoxSubTypes.refBoxTable:
      case enumBoxSubTypes.refChart:
      case enumBoxSubTypes.enumeratedTable:
      case enumBoxSubTypes.refBoxLegend:
        options = [
          {
            label: appstr("Box Properties"),
            dataTestId: "ctx-menu-box-properties",
            value: "Box Properties",
            icon: "ruler-triangle",
            divider: true,
            clickHandler: handleClickCommand("boxlayouteditor")
          },
          {
            label: appstr("Delete"),
            dataTestId: "ctx-menu-delete",
            value: "Delete",
            icon: "trash-can",
            clickHandler: handleClickCommand("DeleteSelection")
          }
        ];
        break;
      case enumBoxSubTypes.autoText:
      case enumBoxSubTypes.textBox:
        options = [
          {
            label: appstr("Delete"),
            dataTestId: "ctx-menu-delete",
            value: "Delete",
            icon: "trash-can",
            clickHandler: handleClickCommand("DeleteSelection")
          }
        ];
        break;
      case enumBoxSubTypes.picture:
        options = [
          {
            label: appstr("resizeimage"),
            dataTestId: "ctx-menu-open-image",
            value: "Resize Image",
            icon: "arrows-maximize",
            clickHandler: handleClickCommand("imageprops"),
            divider: true
          },
          {
            label: appstr("Delete"),
            dataTestId: "ctx-menu-delete",
            value: "Delete",
            icon: "trash-can",
            clickHandler: handleClickCommand("DeleteSelection")
          }
          /* TODO restore photo details
          {
            label: appstr("Details"),
            dataTestId: "ctx-menu-details-image",
            value: "Details Image",
            icon: "circle-info",
            clickHandler: handleClickCommand("imageinfo")
          }
           */
        ];
        break;
    }
    return options;
  };

  return (
    <ContextMenu
      floatingCtrlRef={props.floatingCtrlRef}
      openCtrlRef={openCtrlRef}
      options={BuildOptions()}
    />
  );
};
